import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CommonStorageService } from '../services/storage/common-storage.service';

@Injectable()
export class BaseUrlInterceptor implements HttpInterceptor {

    private readonly DYNAMIC_BASE_URL_KEY = 'dynamic_base_url';

    constructor(private commonStorage: CommonStorageService) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        if (req.url.startsWith('http')) {
            return next.handle(req);
        }

        const isCheckEndpoint = req.url === '/check';
        const baseUrl = isCheckEndpoint ? environment.BASE_URL : this.commonStorage.get(this.DYNAMIC_BASE_URL_KEY) || environment.BASE_URL;

        const modifiedReq = req.clone({ url: `${baseUrl}${req.url}`});

        return next.handle(modifiedReq);
    }
}